import React, { useEffect, useRef, useState } from 'react'
import { useNewsUpdateQuery, useUpdateSaveNewsMutation } from '../../store/ReactWebSiteApi';
import { Form, Input, message, Modal } from 'antd';
import MyEditor from '../../cpn/MyEditor';
import NewsTypeForm from '../newsType/NewsTypeForm';
import UploadOne from '../../cpn/UploadOne';
import GetUser from '../../cpn/GetUser';

function NewsEdit(props) {
    const [open, setOpen] = useState(false);
    const [form] = Form.useForm();
    const editForm = useRef()
    const {data,isSuccess} = useNewsUpdateQuery({en_id:props.en_id},{skip:!open})
    useEffect(() => {
        if(isSuccess){
            if(data.Status==='success'){
                // console.log(data);
                editForm.current.setFieldsValue({
                    en_name:data.Result.en_name,
                    en_content:data.Result.en_content,
                    en_image:data.Result.en_image,
                    en_bianji:data.Result.en_bianji,
                    en_chushen:data.Result.en_chushen,
                    en_zhongshen:data.Result.en_zhongshen,
                    en_type_id:[data.Result.en_type_id],
                })
                setInfo(prevState=>({...prevState,
                    en_name:data.Result.en_name,
                    en_content:data.Result.en_content,    
                    en_type_id:data.Result.en_type_id,            
                    en_type_name:data.Result.en_type_name,            
                    en_image:data.Result.en_image,   
                    en_bianji:data.Result.en_bianji,
                    en_chushen:data.Result.en_chushen,
                    en_zhongshen:data.Result.en_zhongshen,         
                }))
            }
        }
    },[data,isSuccess])
    const [updateSaveNews] = useUpdateSaveNewsMutation()
    const [info, setInfo] = useState()
    const onCreateEdit = () => {
        updateSaveNews({
            "en_content" : info.en_content,
            "en_e_id" : localStorage.getItem('e_id'),
            "en_id" : props.en_id,
            "en_image" : info.en_image,
            "en_name" : info.en_name,
            "en_type_id" :info.en_type_id,
            "en_type_name" : info.en_type_name,
            "en_bianji" : info.en_bianji,
            "en_chushen" : info.en_chushen,
            "en_zhongshen" : info.en_zhongshen,
            "en_update_uid" : localStorage.getItem('eu_id'),
            "en_update_uname" : localStorage.getItem('eu_name'),
        }).then((res) => {
            // console.log(res);
            if (res.data.Status === 'success') {
                message.success('修改成功！')
                setOpen(false)                                   
            }
            if (res.data.Status === 'fail') {
                message.error('修改失败！'+res.data.Message)
            }
        })
    }
    return (
        <>
            <a onClick={() => {setOpen(true)}}>修改</a>   
             <Modal
                open={open}
                width={1000}
                title='修改新闻'
                okText="提交"
                cancelText="取消"
                onCancel={() => {setOpen(false);}}
                onOk={() => {
                    form
                        .validateFields()
                        .then((values) => {
                            form.resetFields();
                            onCreateEdit(values);
                        })
                        .catch((info) => {
                            console.log('Validate Failed:', info);
                        });
                    
                }}
            >
                <Form
                    form={form}
                    layout="horizonal"
                    name="form_client_edit"
                    labelCol={{ span: 5 }}
                    ref={editForm}
                >
                    <NewsTypeForm
                        name='en_type_id'
                        required
                        onChange={(e,f) => {setInfo(prevState=>({...prevState,en_type_id:e,en_type_name:f}))}}
                    />
                    <Form.Item name="en_name" label='新闻标题' wrapperCol={{span:15}}>
                        <Input  onChange={(e) => {setInfo(prevState=>({...prevState,en_name:e.target.value}))}}/>
                    </Form.Item>
                    <Form.Item name="en_content" label='新闻正文' wrapperCol={{span:15}}>
                        <MyEditor onChange={(e) => {setInfo(prevState=>({...prevState,en_content:e}))}}/>
                    </Form.Item>
                    <UploadOne
                        fileStr={(e) => {setInfo(prevsState=>({...prevsState,en_image:e,}))}}
                        label='首图'
                        wrapperCol={{span:20}}
                        required
                        name='en_image'
                    />
                    <GetUser
                        label='编辑'
                        wrapperCol={{span:5}}
                        required
                        getUser={(e,f) => {
                            setInfo(prevsState=>({...prevsState,en_bianji:f}))
                        }}
                        name='en_bianji'
                    />
                    <GetUser
                        label='初审'
                        wrapperCol={{span:5}}
                        required
                        getUser={(e,f) => {setInfo(prevsState=>({...prevsState,en_chushen:f}))}}
                        name='en_chushen'
                    />
                    <GetUser
                        label='终审'
                        wrapperCol={{span:5}}
                        required
                        getUser={(e,f) => {setInfo(prevsState=>({...prevsState,en_zhongshen:f}))}}
                        name='en_zhongshen'
                        
                    />
                </Form>
                
            </Modal>

        </>
    )
}

export default NewsEdit